import AlertIcon from "../Icons/AlertIcon";
import DragDocumentIcon from "../Icons/DragDocumentIcon";

const DocumentNodeHeader = ({
  className,
  number,
  confidence,
  threshold,
  setHover,
}) => {
  const isLowConf = confidence < threshold;
  const bgColor = isLowConf ? "bg-true-maroon" : "bg-true-green";
  return (
    <div
      className={`${className} ${bgColor} grab p-1 grid`}
      style={{
        gridTemplateColumns: "1fr 1fr 1fr",
      }}
      title="Drag Document"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="bg-white w-fit px-1 text-sm rounded flex items-center">
        {number}
      </div>
      <DragDocumentIcon
        size={20}
        className={"white r-90 justify-self-center"}
      />
      <div
        className="text-sm bg-white rounded flex items-center w-fit justify-self-end"
        title={`${isLowConf ? "Low Confidence" : "Confidence"}`}
      >
        <div className="px-1">{`${Math.min(confidence, 100)}%`}</div>
        {isLowConf && <AlertIcon size={20} />}
      </div>
    </div>
  );
};

export default DocumentNodeHeader;
